import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice-btn-pause",
  "use": "icon-notice-btn-pause-usage",
  "viewBox": "0 0 53 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 51\" fill=\"none\" id=\"icon-notice-btn-pause\">\n  <circle cx=\"26.5\" cy=\"25.5\" r=\"23.5\" stroke=\"currentColor\" stroke-width=\"2\" />\n  <path d=\"M20 17h5v17h-5V17zm13 0h5v17h-5V17z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notice/notice-btn-pause.svg
// module id = 3gcu
// module chunks = 24